import { environment } from '../../../environments/environment';

/**
 * Construit l'URL publique MinIO à partir d'une **clé d'objet** renvoyée par le
 * back.
 *
 * Le back stocke/retourne une clé nue (ex. `invoices/INV-2026-00012.pdf`, ou le
 * corps texte de `GET /invoices/{id}/download`), **pas** une URL complète. Le
 * front la préfixe par `environment.minioBaseUrl`
 * (`https://minio-api.nawam.net/nawam`).
 *
 * - `null`/vide → `null` (le call site décide quoi afficher).
 * - Déjà absolue (`http(s)://…`) → renvoyée telle quelle (robustesse si le back
 *   se met un jour à renvoyer une URL complète).
 * - Slashs en trop (préfixe / clé) normalisés.
 */
export function minioUrl(keyOrUrl: string | null | undefined): string | null {
  if (!keyOrUrl) return null;
  const v = keyOrUrl.trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  const base = environment.minioBaseUrl.replace(/\/+$/, '');
  const key = v.replace(/^\/+/, '');
  return `${base}/${key}`;
}
